import { html } from "lit";
import { u } from "@converse/headless";

export default (video_id, url, hide_url) => {
    const { hostname } = u.getURL(url);
    return html`<figure><iframe style="border-radius:12px" src="https://www.tiktok.com/embed/v2/${video_id}" width="325" height="575" frameborder="0" allowfullscreen="" allow="autoplay; fullscreen" loading="lazy"></iframe>${hide_url ? "" : html`<a target="_blank" rel="noopener" title="${url}" href="${url}">${hostname}</a>`}</figure>`;
};
